import type { AuthProvider } from "react-admin";

import { API_URL } from "./config";

export const authProvider: AuthProvider = {
  async login({ username, password }) {
    const r = await fetch(`${API_URL}/admin/auth/login`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: username, password }),
    });
    if (!r.ok) {
      const text = await r.text().catch(() => "");
      throw new Error(text || "Неверный логин или пароль");
    }
  },

  async logout() {
    await fetch(`${API_URL}/admin/auth/logout`, {
      method: "POST",
      credentials: "include",
    }).catch(() => undefined);
  },

  async checkAuth() {
    const r = await fetch(`${API_URL}/admin/auth/me`, { credentials: "include" });
    if (!r.ok) throw new Error("not authenticated");
  },

  async checkError(error) {
    const status = error?.status;
    if (status === 401 || status === 403) throw new Error("session expired");
  },

  async getIdentity() {
    const r = await fetch(`${API_URL}/admin/auth/me`, { credentials: "include" });
    if (!r.ok) throw new Error("not authenticated");
    const data = (await r.json()) as { id: string; email: string; role?: string };
    return { id: data.id, fullName: data.email };
  },

  async getPermissions() {
    const r = await fetch(`${API_URL}/admin/auth/me`, { credentials: "include" });
    if (!r.ok) throw new Error("not authenticated");
    const data = (await r.json()) as { role?: string };
    return data.role ?? "admin";
  },
};
